import React, { useState, useEffect, useContext } from "react";
import Preview from './Preview';
import { parseText } from "../../Helpers/parse";
import { GlobalContext } from "../../Context/GlobalContext";

const SearchItem = ({
  color,
  setFile,
  VideoObj,
  searchTerm,
}) => {

  const [searchResults, setSearchResults] = useState("");
  const { config, darkMode } =
    useContext(GlobalContext);
  
  useEffect(() =>{    
    Object.keys(VideoObj.metadata).forEach(obj => {
      if (obj !== "rpath" && obj !== "original filename") {
        if (`${VideoObj.metadata[obj]}`.toLowerCase().includes(searchTerm.toLowerCase())) {
          let st = obj === "filename" ? "Title" : obj;
          setSearchResults(`${st.substring(0,1).toUpperCase()}${st.substring(1).toLowerCase()}: ${VideoObj.metadata[obj]}`)
        }
      }
    });
  },[]);

  // useEffect(() =>{
  //   if (item._id !== _id || search !== search) {
  //     set_id(item._id);
  //     setSearch(search);

  //     Object.keys(item.metadata).forEach(obj => {
  //       if (obj !== "rpath" && obj !== "original filename") {
  //         if (`${item.metadata[obj]}`.toLowerCase().includes(searchTerm.toLowerCase())) {
  //           let st = obj === "filename" ? "Title" : obj;
  //           setSearchResults(`${st.substring(0,1).toUpperCase()}${st.substring(1).toLowerCase()}: ${item.metadata[obj]}`)
  //         }
  //       }
  //     });
  //   }
  // },[item._id, search])

  let views = 0;
  if(VideoObj.views) {
    if(VideoObj.views instanceof Array) {
      views = VideoObj.views.length
    } else {
      views = VideoObj.views
    }
  }

  return (
    <li className={darkMode?"dark list-group-item":"list-group-item"}>
      <div className="flex-row">

        {/* thumbnail preview */}
        <div className="col-3" onClick={() => setFile()}>
          <Preview videoId={VideoObj._id} color={color}/>
        </div>

        <div className="ml-3">
          {/* video title */}
          <div>{VideoObj.metadata.filename}</div>

          {/* view counts */}
          <div className={darkMode?"dark dt":"dt"}>
            {!config.hideViews && <>
              {views === 1 ? `${views} view` : `${views} views`}
              <strong>·</strong>
            </>}
            {parseText(new Date(VideoObj.date))}
          </div>

          {/* search results metadata */}
          <div>
            {searchResults
              .split(new RegExp(searchTerm, "i"))
              .map((item, index) => {
                if (index === searchResults.split( new RegExp(searchTerm, "i")).length - 1) {
                  return <span key={item}>{item}</span>;
                } else {
                  return (
                    <span key={item}>
                      {item}
                      <b>{" " + searchTerm}</b>
                    </span>
                  );
                }
              })}
          </div>

        </div>
      </div>
    </li>
  );
}

export default SearchItem;
